import React, { ReactNode } from "react";
import { ErrorBoundary } from "@sentry/nextjs";
import { isDev } from "@/helpers";

type ErrorBoundaryProviderProps = {
  children: ReactNode;
};

export default function ErrorBoundaryProvider({
  children
}: ErrorBoundaryProviderProps) {
  if (!isDev()) {
    return (
      <ErrorBoundary
        fallback={
          <div className="mt-5 text-center">
            <h2>Erro inesperado! caso persista, favor contatar o suporte</h2>
          </div>
        }
      >
        {children}
      </ErrorBoundary>
    );
  }
  return <>{children}</>;
}
